import MeasureItem from './MeasureItem'
import Calc from './Calc'
import DateUtils from '../utils/DateUtils'
const UI = require('./UI')
var desc = "您的蛋白质量为 XXkg ，处于YY状态。"
const STAND_LEVEL = 1
export default class ProteinMassReport {
  /**
   * 含水量
   */
  static calcProteinMass(measure) {
    return (measure.weight * (measure.protein / 100)).toFixed(2)
  }

  static isEnable(measure) {
    return true
  }

  static build(measure) {

    const item = new MeasureItem()
    let values = ProteinMassReport.calcProteinMass(measure)
    let value = ProteinMassReport.calcProteinMass(measure)
    let weight = measure.weight

    if (measure.gender == 1) {
        values = [((16 / 100) * weight).toFixed(2),((18 / 100) * weight).toFixed(2)];
    } else {
        values = [((14 / 100) * weight).toFixed(2),((16 / 100) * weight).toFixed(2)];
    }

    const boundaries = values
    const level = Calc.calcLevel(value, boundaries, STAND_LEVEL)

    const isStand = level == STAND_LEVEL

    item.name = "蛋白质量"
    item.boundaries = boundaries
    item.value = value
    item.levelNames = ["偏低", "标准", "充足"]
    item.isStand = isStand
    item.unit = "kg"
    item.desc = desc.replace("XX", item.value).replace("YY", item.levelNames[level])
    item.level = level
    item.bar = [UI.color.report_lower, UI.color.report_stand, UI.color.report_higher]

    item.min = 5
    item.max = 30

    if (!isStand) {
      let offset = 0
      if (level < STAND_LEVEL) {
        offset = value - boundaries[STAND_LEVEL - 1]
      } else {
        offset = value - boundaries[STAND_LEVEL]
      }
      item.offset = offset
    }

    return item
  }

}



// WEBPACK FOOTER //
// ./src/report/ProteinMass.js